import { useState } from 'react';

import { BasketRow } from 'components/Basket';
import Button from 'components/Button';
import {
	LoadingBasketRowSkeletonItem,
	LoadingSkeleton,
} from 'components/LoadingSkeleton';
import Popover from 'components/Popover';
import { useSelectedStore } from 'contexts';
import { useDpApiEndpoint } from 'endpoints/dpApi';
import type { VariantId } from 'models/product';
import { range } from 'utils/helpers';

interface Props {
	bundleId: VariantId;
	className?: string;
	title: string;
	triggerButtonText: string;
}

export default function FindBundleProductPopover({
	bundleId,
	className,
	title,
	triggerButtonText,
}: Props) {
	const { selectedStore } = useSelectedStore();

	const [isOpen, setIsOpen] = useState(false);
	const { data: basketRows, isLoading } = useDpApiEndpoint(
		selectedStore?.id && isOpen
			? {
					name: 'GetBundleVariants',
					pathParams: { bundleId },
					queryParams: { storeId: selectedStore.id },
				}
			: null,
	);

	return (
		<>
			<Button
				className={className}
				onClick={() => setIsOpen(true)}
				variant="text-inherit"
				hasExpandedHitArea
				aria-haspopup="dialog"
			>
				{triggerButtonText}
			</Button>
			<Popover title={title} isOpen={isOpen} onClose={() => setIsOpen(false)}>
				{isLoading && (
					<LoadingSkeleton className="space-y-8">
						{range(3).map((i) => (
							<LoadingBasketRowSkeletonItem
								key={i}
								hasStoreStock
								hasShelfInformation
							/>
						))}
					</LoadingSkeleton>
				)}
				{!isLoading && (
					<ul className="space-y-8">
						{basketRows?.map((row) => (
							<BasketRow
								key={row.variantId}
								containerElement="li"
								hasShelfInformation
								hasStoreStock
								row={row}
								subtitleVariant="article-number"
							/>
						))}
					</ul>
				)}
			</Popover>
		</>
	);
}
FindBundleProductPopover.displayName = 'FindBundleProductPopover';
